module.exports = __webpack_public_path__ + "img/undraw_File_searching_re_3evy.2ef3ee3e.svg";